import _ from 'lodash';

/**
 * This function check if uuid is for new page
 * @param uuid string
 * @returns whether its new or not
 */
export const IsNewItemPage = (uuid: string) => uuid === 'new';

export type JsonifiedFile = {
  name: string,
  lastModified: number,
  contentType: string,
  contents: string, // base64 encoded
}

/**
 * Populates the file metadata and asynchronously reads content. Meant to prepare a file to be sent to the API.
 * @param file the base File structure passed by the file input on selection
 * @returns Promise that resolves into the JsonifiedFile structure described above
 */
export const JsonifyFile: (file: File) => Promise<JsonifiedFile> = async (file) => {
  const contentPromise = new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
  const [metadata, contents] = _.split(await contentPromise, ',');
  const [contentType] = _.split(metadata.slice(5), ';');

  return {
    name: file.name,
    lastModified: file.lastModified,
    contents,
    contentType,
  };
};
